<template>
  <div class="top-nav">
    <div class="left">
      <el-icon class="toggle-btn" @click="toggleSidebar">
        <el-icon-menu />
      </el-icon>
      <breadcrumb />
    </div>
    <div class="right">
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="avatar-container">
          <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" class="avatar">
          <span>管理员</span>
          <el-icon><el-icon-arrow-down /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- 删除了个人信息选项 -->
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Breadcrumb from './Breadcrumb.vue'
import { useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'

export default {
  name: 'TopNav',
  components: {
    Breadcrumb
  },
  setup () {
    const router = useRouter()

    const toggleSidebar = () => {
      // 这里可以通过Vuex来控制侧边栏的展开收起
      console.log('Toggle sidebar')
    }

    const handleCommand = (command) => {
      if (command === 'logout') {
        ElMessageBox.confirm(
          '确定要退出登录吗?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          // 清除登录状态
          localStorage.removeItem('token')
          // 跳转到登录页
          router.push('/login')
        }).catch(() => {
          // 取消操作
        })
      }
      // 删除了profile相关的处理逻辑
    }

    return {
      toggleSidebar,
      handleCommand
    }
  }
}
</script>

<style scoped>
.top-nav {
  height: 60px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.left {
  display: flex;
  align-items: center;
}

.toggle-btn {
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
}

.right {
  display: flex;
  align-items: center;
}

.avatar-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>
